module.exports = __webpack_public_path__ + "img/HKIFOA-logo.a59ccd5b.png";